import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { getUserDetails } from "../auth";
import { API } from "../endpoints";

export const CALENDLY_EVENT_TYPES_QUERY_KEY = ["calendly-event-types"];

export const CALENDLY_EVENT_TYPES_QUERY_OPTIONS = {
  retry: false,
  retryOnMount: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
} as const;

export function syncWithCalendlyAuth() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.CALENDLY.GET_CALENDLY_URL,
        payload: {},
        config: {},
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function revokeCalendlyAuth() {
  return async function (dispatch, getState) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.CALENDLY.REVOKE_CALENDLY_URL,
        payload: {},
        config: {},
      })
    );

    if (res.success) {
      const userId = getState().auth.user.id;
      dispatch(getUserDetails(userId));
    }

    return res;
  };
}

export function checkCalendlyAuthCode(code) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.CALENDLY.CHECK_AUTH_CODE(code),
        payload: {},
        config: {},
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export type CalendlyEventType = {
  uri: string;
  name: string;
  duration: number;
  active: boolean;
  slug: string;
  schedulingUrl: string;
  isDefault: boolean;
};

export type CalendlyEventTypesResponse = {
  success: boolean;
  data: {
    defaultEventTypeUri: string | null;
    eventTypes: CalendlyEventType[];
  };
  message?: string;
};

export function getCalendlyEventTypes() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.CALENDLY.GET_EVENT_TYPES,
        payload: {},
        config: {
          notifyError: true,
          notifySuccess: false,
        },
      })
    );

    if (res?.success === false) {
      throw new Error(res?.message || "Failed to load Calendly event types");
    }

    return res as CalendlyEventTypesResponse;
  };
}

export function setDefaultCalendlyEventType(eventTypeUri: string) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.CALENDLY.SET_DEFAULT_EVENT_TYPE,
        payload: { eventTypeUri },
        config: {
          notifyError: true,
          notifySuccess: true,
          successMessage: "Default Calendly event type updated.",
        },
      })
    );

    if (res?.success === false) {
      throw new Error(
        res?.message || "Failed to update default Calendly event type"
      );
    }

    return res;
  };
}
